export function formatPhoneNumber(phone: string | undefined): string {
    if (!phone) {
        return '';
    }
    let _phone = phone.replace(/ /g, '');
    if (_phone.length > 3) {
        _phone = _phone.substring(0, 3) + ' ' + _phone.substring(3);
    }
    return _phone;
}
